import * as React from "react";
import '../styles/styleMenage.css'
import axiosInstance from "../auth/axiosInstance";
import FooterStatus from "../components/footerStatus/footerStatus";
import { ModalBlock } from "../components/modalBlockEmail/modalBlockEmail";
import { Button } from "../components/button/button";
import { Table } from '../components/ListUsers/Table'
import { Search } from "../components/search/search";
import { Paginate } from "../components/Paginate/paginate";

function Menage() {
    const [users, setUsers] = React.useState([])
    const [showFeedback, setShowFeedback] = React.useState(false);
    const [reload, setReload] = React.useState(false);
    const [typeRequest, setTypeRequest] = React.useState(0);
    const [filterData, setFilterData] = React.useState([])
    const [showModal, setShowModal] = React.useState(false)
    const [currentPageData, setCurrentPageData] = React.useState([])

    React.useEffect(() => {
        axiosInstance("access-control")
            .then((res) => {
                setUsers(res.data);
                setFilterData(res.data);
                setReload(false)
            })
            .catch((err) => console.log(err));
    }, [reload])

    function deletar(id) {
        axiosInstance.delete(`access-control/${id}`)
            .then((res) => {
                if (res.status === 200) {
                    setTimeout(() => {
                        setShowFeedback(false);

                    }, 10000);
                    setShowFeedback(true);
                    setTypeRequest(2);
                    setReload(true);
                }
            })
            .catch((err) => {
                console.log(err);
                setTypeRequest(3);
            });
    }

    return (
        <section className="body-list-notas">
            <div className="body-list-header">
                <h1>Access Management</h1>
            </div>
            <div className="body-list-notas_content_filter">
                <Search set={setFilterData} initialData={users} placeholder={'Search a Colab'} className='body-list-notas_content_filter_search' style={{ width: '75%' }} />
                <Button onClick={() => setShowModal(true)} style={{ width: '25%', background: '#C35E5E', border: 'none' }} className='body-list-notas_content_filter_button button-blacklist' label={`Add Colaborator`} />
            </div>
            <Table className={'show-in-desk'} onClick={deletar} style={{ maxHeight: '75vh', overflowY: 'auto' }} arr={currentPageData} type={3} />
            <ModalBlock show={showModal} set={setShowModal} feedback={setShowFeedback} typeRequest={setTypeRequest} reload={setReload} />
            <Paginate arr={filterData} set={setCurrentPageData} />
            <FooterStatus
                show={showFeedback}
                showButton={false}
                cancel={() => setShowFeedback(false)}
                text={
                    typeRequest === 1
                        ? `Access successfully added.`
                        : typeRequest === 2
                            ? `Access successfully deleted.`
                            : `Error in the process of adding or deleting access.`
                }

            />
        </section>
    )
}

export default Menage